import * as React from 'react';
import { Col, Row } from 'reactstrap';
import PosterPersonTitle from './PosterPersonTitle';
import PosterPersonImage from './PosterPersonImage';
import PosterPersonInformation from './PosterPersonInformation';
import { IPosterPrintPersonProps } from '../PosterPrint';

export const PosterPrintRowPerson = (props: IPosterPrintPersonProps) => {
  const portrait = props.personInfo && props.personInfo.images && props.personInfo.images && props.personInfo.images.length > 0 ? props.personInfo.images[0] : 'https://s3.us-east-2.amazonaws.com/caseview-children-assets/Images/no_photo_found.jpg'
  return (
    <Col className={'col-12'}>
      <Row>
        <Col className={`col-12 poster-child-container child-complete-row ${props.className || ''}`}>
          <PosterPersonTitle fullName={props.personInfo && props.personInfo.fullName} />
        </Col>
      </Row>
      <Row>
        <Col className={`col-${props.colSize} poster-child-container child-complete-row ${props.className || ''}`}>
          <PosterPersonImage portrait={portrait} />
        </Col>
        <Col className={`col-${props.colSizeInformation} poster-child-container child-complete-row ${props.className || ''}`}>
          <PosterPersonInformation {...props} />
        </Col>
      </Row>
    </Col>
  )
};
